import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";
import useOnboardingData from "@/store/onboarding-data";

export type ToneStyle = "casual" | "formal" | "playful" | "professional";

export interface StorePersonality {
    store_id: string; // UUID of the store
    id?: string;

    company_name?: string | null; // Store or company name
    business_focus?: string | null; // Description of business purpose

    greetings_examples?: string | null; // Example greetings (separated by ||)
    thanks_examples?: string | null; // Example thank-you messages
    repeat_examples?: string | null; // When user repeats or returns
    fallback_response?: string | null; // When bot doesn't understand
    off_topic_response?: string | null; // When user goes off-topic
    hook_response?: string | null; // Conversational hook

    tone_style?: ToneStyle | null; // Chatbot tone/personality
    emoji_enabled?: boolean | null; // Enable emojis in messages
}

export const getChatbotPromptSettings = async (storeId: string) => {
    try {
        const response = await Axios.get(`/chatbot_prompt_settings/${storeId}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetChatbotPromptSettings = () => {
    const { storeData } = useOnboardingData();
    const storeId = storeData?.id || "";

    return useQuery({
        queryKey: ["get_chatbot_prompt_settings", storeId],
        queryFn: () => getChatbotPromptSettings(storeId),
        enabled: !!storeId,
    });
};
